import { Box, CssBaseline, Toolbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Outlet, Link, useNavigate, Navigate } from "react-router-dom";
import Header from './Header';
import Navbar from './Navbar';
import SideNav from './SideNav';




const DashboardLayout = ({type}) => {
  
return (

  <Box sx={{ display: "flex" }}>
  <CssBaseline />
  <Header />
  <Box 
    component="main"
    sx={{
      flexGrow: 1,
      p: 3,
      width: { md: `calc(100% - ${240}px)`, overflow: "auto" },
    }}
  >
    <Toolbar />




      <Outlet context={{type}}/>


      </Box>
      </Box>
)
};

export default DashboardLayout;
